<template>
  <div class="mod-user">
    <!-- 搜索栏 -->
    <div class="searchBox" :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm.paramMap" size="small">
        <el-form-item label="版本号">
          <el-input v-model="dataForm.paramMap.name" placeholder="版本号" clearable></el-input>
        </el-form-item>
        <el-form-item label="创建账号">
          <el-input v-model="dataForm.paramMap.createdName" placeholder="创建账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="版本终端">
          <el-select class="item-choose" @change="getDataList" v-model="dataForm.paramMap.terminal" size="small" filterable clearable placeholder="请选择">
            <el-option label="司机端" value="0"></el-option>
            <el-option label="调度端" value="1"></el-option>
            <el-option label="客户端" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本类型">
          <el-select class="item-choose" @change="getDataList" v-model="dataForm.paramMap.type" size="small" filterable clearable placeholder="请选择">
            <el-option label="android" value="0"></el-option>
            <el-option label="ios" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否最新">
          <el-select class="item-choose" @change="getDataList" v-model="dataForm.paramMap.status" size="small" filterable clearable placeholder="请选择">
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
              v-model="dataForm.paramMap.times"
              :picker-options="pickerOptions"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button @click="() => this.dataForm.paramMap = {}" type="info">重置</el-button>
          <el-button @click="addOrUpdate('发布(新增)',null)" type="success">发布版本</el-button>
          <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格栏 -->
    <div class="tableBox"  :style="{ position: 'relative' }">
      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>

      <!-- 表格 -->
      <el-table :data="dataList"
                ref="tableRef"
                @row-click="rowClick"
                :row-style="selectedHighlight"
                height="72vh"
                size="small"
                v-loading="dataListLoading"
                border
                style="width: 100%;"
                :cell-class-name="getCellClassName">
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 版本终端 -->
            <template v-if="item.prop == 'terminal'">
              <el-tag v-if="scope.row.terminal == 0" size="small" type="success">司机端</el-tag>
              <el-tag v-if="scope.row.terminal == 1" size="small" type="info">调度端</el-tag>
              <el-tag v-if="scope.row.terminal == 2" size="small" type="warning">客户端</el-tag>
            </template>
            <!-- 版本类型 -->
            <template v-else-if="item.prop == 'type'">
              <el-tag v-if="scope.row.type == 0" size="small" type="warning">android</el-tag>
              <el-tag v-else size="small" type="info">ios</el-tag>
            </template>
            <!-- 版本状态 -->
            <template v-else-if="item.prop == 'status'">
              <el-switch
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  @change="setDefaultOrNot(scope.row)">
              </el-switch>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>

        <af-table-column fixed="right" header-align="left" width="120" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addOrUpdate('发布(修改)',scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row)">删除</el-button>
          </template>
        </af-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="dataForm.page"
                     :page-sizes="[20, 50, 100]" :page-size="dataForm.size" :total="dataForm.total"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <!-- 新增/修改 -->
    <el-dialog :title="version.title" :visible.sync="version.show" width="40%" :destroy-on-close="true" :close-on-click-modal="false">
      <el-form :model="version" :rules="version.rules"  size="small" label-width="100px" ref="versionFormRef">
        <el-form-item label="版本号" prop="info.name">
          <el-input v-model="version.info.name" placeholder="版本号" clearable />
        </el-form-item>
        <el-form-item label="版本链接" prop="info.link">
          <el-input v-model="version.info.link" placeholder="请上传或输入" clearable />
          <el-upload class="upload-demo" drag action="#" :auto-upload="false" :show-file-list="false" :on-change="handleFileChangeV2">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
        <el-form-item label="版本终端" prop="info.terminal">
          <el-select class="item-choose" v-model="version.info.terminal" size="small" filterable clearable placeholder="请选择">
            <el-option label="司机端" value="0"></el-option>
            <el-option label="调度端" value="1"></el-option>
            <el-option label="客户端" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本类型" prop="info.type">
          <el-select class="item-choose" v-model="version.info.type" size="small" filterable clearable placeholder="请选择">
            <el-option label="android" value="0"></el-option>
            <el-option label="ios" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否最新"  prop="info.status">
          <el-select class="item-choose" v-model="version.info.status" size="small" filterable clearable placeholder="请选择">
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="version.info.remark" type="textarea" placeholder="备注" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="version.show = false">取消</el-button>
        <el-button type="primary" @click="versionSubmit" :loading="version.submitLoading">{{ version.info.id ? '发布(修改)' : '发布(新增)' }}</el-button>
      </span>
      <!--<input type="file" ref="fileInput" style="display: none" @change="handleFileChange">-->
    </el-dialog>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />
  </div>
</template>
<script>
import OSS from 'ali-oss';
import configTable from '@/components/table'
import * as myJsonClon from "@/utils/myJsonClone";
import * as myPageColumConfig  from "@/utils/pageColumConfig";
export default {
  data() {
    return {
      // -----------------动态表格模式start-----------------
      config: myPageColumConfig.versionV,
      // -----------------动态表格模式end-----------------


      // 搜索信息
      dataForm: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },

      // 表格
      dataList: [],
      getIndex: -1,
      dataListLoading: false,

      // 添加/修改
      version: {
        info: {
          name: '',
          link: '',
          terminal: '0',
          type: '0',
          status: '1'
        },
        rules: {
          'info.name': [
            { required: true, message: '请输入版本号', trigger: 'blur' },
            { min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
          ],
          'info.link': [
            { required: true, message: '请上传或输入链接', trigger: 'blur' },
          ],
          'info.terminal': [
            { required: true, message: '请选择终端', trigger: 'blur' },
          ],
          'info.type': [
            { required: true, message: '请选择类型', trigger: 'blur' },
          ],
          'info.status': [
            { required: true, message: '请选择状态', trigger: 'blur' },
          ],
        },
        title: '',
        show: false,
        submitLoading: false,
      },
      ossClient: null,
      ossUploadPrefix: null,
    }
  },
  components: {configTable},
  created() {
    // 获取OSS配置
    let that = this
    that.$http({
      url: that.$http.adornUrl('/sys/appConfig/get'),
      method: 'get',
      params: that.$http.adornParams({ type: 2 })
    }).then(({ data }) => {
      if (data && data.configValue) {
        let configValue = JSON.parse(data.configValue);
        that.ossClient = new OSS({
          endpoint: configValue.endpoint,
          accessKeyId: configValue.accessKeyId,
          accessKeySecret: configValue.accessKeySecret,
          bucket: configValue.bucket
        });
        that.ossUploadPrefix = configValue.tenantId + '/' + (configValue.path.endsWith('/') ? configValue.path : configValue.path + '/')
      }
    })

    // 初始化OSS对象
  },
  activated() {
    this.initConfigTable();
    this.getDataList()
  },
  methods: {
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------

    /**
     * 点击表格变色
     * @param row 当前行数据
     * @param rowIndex 当前行号
     * @returns {{"background-color": string}}
     */
    selectedHighlight({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    rowClick(row) {
      this.getIndex = row.index
    },

    /**
     * 每页大小
     * @param val 当前选中页大小
     */
    sizeChangeHandle(val) {
      this.dataForm.size = val
      this.dataForm.page = 1
      this.getDataList()
    },

    /**
     * 当前页
     * @param val 当前选中的页数
     */
    currentChangeHandle(val) {
      this.dataForm.page = val
      this.getDataList()
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true

      if (this.dataForm.paramMap.times) {
        this.dataForm.paramMap.createTimeStart = this.dataForm.paramMap.times[0]
        this.dataForm.paramMap.createTimeEnd = this.dataForm.paramMap.times[1]
      }

      // 执行
      this.$http({
        url: this.$http.adornUrl('/system_version_management/page'),
        method: 'post',
        data: this.dataForm
      }).then(({ data }) => {
        this.dataList = data.records
        this.dataForm.total = data.total
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 删除
    deleteHandle(row) {
      this.$confirm('确定进行【删除】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/system_version_management/' + row.id),
          method: 'delete',
        }).then(({ data }) => {
          if (data) {
            this.getDataList();
          }
        }).finally(() => {})
      }).catch(() => { })
    },

    // 设置状态
    setDefaultOrNot (row) {
      let title = row.status == 0 ? '取消最新' : '设置最新'
      this.$confirm('确定对【' + row.name + '】进行【' + title + '】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/system_version_management/setStatus/${row.id}/${row.status}`),
          method: 'get',
        }).then(({ data }) => {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
          })
        })
      }).catch(() => {})
          .finally(() => {
            setTimeout(() => {
              this.getDataList()
            },1000)

          })
    },

    // 发布
    addOrUpdate(title,row) {
      let that = this;
      that.version = this.$options.data().version;
      that.version.info = row ? row : that.version.info;
      that.version.title = title;
      if (that.version.info.id) {
        that.$http({
          url: that.$http.adornUrl(`/system_version_management/${row.id}`),
          method: 'get',
        }).then(({ data }) => {
          if (data) {
            that.version.info = data
          }
        })
      }
      this.version.show = true;
    },
    versionSubmit() {
      let that = this;
      that.$refs.versionFormRef.validate((valid) => {
        if (valid) {
          let info = myJsonClon.getClone(that.version.info);
          that.version.submitLoading = true;
          // 执行
          that.$http({
            url: this.$http.adornUrl('/system_version_management'),
            method: info.id ? 'put' : 'post',
            data: info
          }).then(({ data }) => {
            that.$message.success('处理成功')
            setTimeout(() => {
              that.version.show = false;
              that.getDataList();
            },1000)
          }).finally(() => {
            that.version.submitLoading = false;
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 点击上传按钮触发文件选择 & 文件选择后处理上传
    handleUploadClick() {
      this.$refs.fileInput.click();
    },
    async handleFileChange(event) {
      let that = this;
      let file = event.target.files[0];
      if (!file) {
        event.target.value = '';
        return;
      }

      if (!that.ossUploadPrefix || !that.ossClient) {
        this.$message.error('请前往[系统管理-应用管理-文件上传配置]配置相关材料');
        event.target.value = '';
        return;
      }

      // 显示上传loading
      let loading = that.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        // 3. 生成唯一文件名
        let extension = file.name.split('.').pop();
        let fileName = that.ossUploadPrefix + `version/${Date.now()}_${Math.random().toString(36).substr(2)}.${extension}`

        // 上传至OSS
        let res = await that.ossClient.put(fileName, file);
        that.version.info.link = res.url;
        that.$message.success('上传成功');
      } finally {
        loading.close();
        event.target.value = '';
      }
    },
    async handleFileChangeV2(uploadFile) {
      let that = this;
      let file = uploadFile.raw
      if (!file) {
        return;
      }

      if (!that.ossUploadPrefix || !that.ossClient) {
        this.$message.error('请前往[系统管理-应用管理-文件上传配置]配置相关材料');
        return;
      }

      // 显示上传loading
      let loading = that.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        // 3. 生成唯一文件名
        let extension = file.name.split('.').pop();
        let fileName = that.ossUploadPrefix + `version/${Date.now()}_${Math.random().toString(36).substr(2)}.${extension}`

        // 上传至OSS
        let res = await that.ossClient.put(fileName, file);
        that.version.info.link = res.url;
        that.$message.success('上传成功');
      } finally {
        loading.close();
      }
    },
  }
}
</script>
<style lang="less">
.separatorVV {
  border-top: 2px solid rgba(0, 0, 0, 0.34);
  margin: 10px 0;
}
</style>
